import React from 'react';

interface CptRow {
  multiProcedureDiscount?: boolean;
}

/**
 * Multi-procedure discount display
 */
export const DiscountTemplate: React.FC<{ value: boolean }> = ({ value }) => (
  <span>{value ? 'Yes' : 'No'}</span>
);

// Template function for grid column
export const discountTemplate = (props: CptRow) => (
  <DiscountTemplate value={props.multiProcedureDiscount || false} />
);

export default DiscountTemplate;
